import angular from 'angular';
import forEach from 'lodash.foreach';
import omit from 'lodash.omit';
import union from 'lodash.union';

import template from './group.html';

const base = '/authz/v2';
const scopeUrl = scopeId => `/scopes/${scopeId}/groups`;
const httpOptions = {
  cache: true,
  xsrfHeaderName: 'X-XSRF-TOKEN',
  xsrfCookieName: 'XSRF-TOKEN'
};

const flattenGroup = groups => {
  let result = [];
  forEach(groups, group => {
    result.push(omit(group, 'childGroups'));
    if (group.childGroups) {
      result = union(result, flattenGroup(group.childGroups));
    }
  });
  return result;
};

class Group {

  static get $inject() {
    return ['$element', '$timeout', '$animate', '$http'];
  }

  constructor($element, $timeout, $animate, $http) {
    this.$element = $element;
    this.$timeout = $timeout;
    this.$animate = $animate;
    this.$http = $http;
  }

  $onInit() {
    // Prevent ngAnimate from wreaking havoc with disabled state
    this.$animate.enabled(this.$element, false);
    // Ensure selectedItem has a value as long as the model has a value
    this.ngModel.$render = () => {
      if (!this.selectedItem && this.ngModel.$viewValue && this.ngModel.$viewValue.groupName) {
        this.selectedItem = this.ngModel.$viewValue;
      }
    };
  }

  $onChanges(changes) {
    if (changes.idsScope.currentValue) {
      this.ngModel.$setViewValue();
      this.searchTerm = '';
      this.updateGroups();
    }
  }

  get isDisabled() {
    return !!this.$element.attr('disabled');
  }

  get isReadonly() {
    return !!this.$element.attr('readonly');
  }

  get isClearable() {
    return angular.isDefined(this.$element.attr('clearable')) &&
      this.hasSelectedItem() && !this.isDisabled && !this.isReadonly;
  }

  hasSelectedItem() {
    return this.selectedItem !== undefined;
  }

  clearSelectedItem($event) {
    // we want to the dropdown to remain open when clearing the value
    // this may prevent other open dropdowns from closing however
    $event.stopPropagation();
    $event.preventDefault();
    this.ngModel.$setViewValue(undefined);
    this.searchTerm = '';
    this.groups = this.pristine;
    this.selectedItem = undefined;
  }

  updateGroups() {
    const url = this.idsScope === 'ALL' ? `${base}/groups` : `${base}${scopeUrl(this.idsScope)}`;
    this.groups = this.$http.get(url, httpOptions)
      .then(results => {
        // flatten groups for searching
        this.pristine = results.data;
        this.flatItems = flattenGroup(results.data);

        return results.data;
      });
  }

  selectGroup(group) {
    this.ngModel.$setViewValue(group);
    this.selectedItem = group;
    this.ngModel.$setTouched();
    this.searchTerm = group.groupName;
    this.isOpen = false;
  }

  search() {
    this.groups = this.searchTerm ?
      this.flatItems.filter(item =>
        item.groupName.toLowerCase().includes(this.searchTerm.toLowerCase())) :
      this.pristine;

    this.$element[0].querySelector('.akam-tree-viewport').scrollTop = 0;
  }

  openUnlessDisabled() {
    if (this.isDisabled || this.isReadonly) {
      this.isOpen = false;
    }
  }

  onToggle(open) {
    this.isEditing = open && !(this.isDisabled || this.isReadonly);
    if (this.isEditing) {
      if (this.ngModel.$viewValue && this.ngModel.$viewValue.groupName) {
        this.searchTerm = this.ngModel.$viewValue.groupName;
      }

      this.$timeout(() => {
        const elem = this.$element[0].querySelector('input[type="text"]');
        if (elem && elem.focus) {
          elem.focus();
        }
      });
    }
  }

}

export default {
  require: {
    ngModel: 'ngModel'
  },
  bindings: {
    idsScope: '<',
    placeholder: '@'
  },
  controller: Group,
  template
};
